import React from 'react';
import { useScenario } from '../contexts/ScenarioContext';
import { useLanguage } from '../contexts/LanguageContext';

export default function ScenarioToggle({ className = '' }) {
  const { scenario, setScenario } = useScenario();
  const { language } = useLanguage();

  const labels = {
    fr: { title: 'Scénario', min: 'Minimum', real: 'Réaliste' },
    en: { title: 'Scenario', min: 'Minimum', real: 'Realistic' },
  }[language];

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="scenario-toggle">
      <span className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-semibold">{labels.title}</span>
      <div className="inline-flex bg-black/60 border border-gray-700 rounded-lg p-1">
        <button
          type="button"
          onClick={() => setScenario('minimum')}
          data-testid="scenario-min-btn"
          className={`px-4 py-1.5 text-xs font-bold rounded-md transition-all duration-200 ${
            scenario === 'minimum'
              ? 'bg-gradient-to-r from-lime-500 to-cyan-500 text-black shadow-[0_0_15px_rgba(132,204,22,0.4)]'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          {labels.min}
        </button>
        <button
          type="button"
          onClick={() => setScenario('realiste')}
          data-testid="scenario-real-btn"
          className={`px-4 py-1.5 text-xs font-bold rounded-md transition-all duration-200 ${
            scenario === 'realiste'
              ? 'bg-gradient-to-r from-lime-500 to-cyan-500 text-black shadow-[0_0_15px_rgba(132,204,22,0.4)]'
              : 'text-gray-400 hover:text-white'
          }`}
        >
          {labels.real}
        </button>
      </div>
    </div>
  );
}
